module.exports = __webpack_public_path__ + "img/gold18.991d1e32.svg";